/**
 * One answer, as a human reads it.
 *
 * Answers are not all strings: a choice is `{ value, other }`, a tick list is an array, a
 * fillable grid is an array of rows, and a signature is `{ name, agreed, signed_at }`. Before
 * this, the printed sheet ran `String(answer)` over all of them and put "[object Object]" on
 * paper the practitioner was about to hand a client.
 */
export const answerText = (field, value) => {
  if (value === undefined || value === null || value === '') return '';

  if (field?.type === 'signature') {
    if (!value.name && !value.agreed) return '';
    const when = value.signed_at ? new Date(value.signed_at) : null;
    const stamp = when && !Number.isNaN(when.getTime())
      ? when.toLocaleString(undefined, { year: 'numeric', month: 'long', day: 'numeric',
                                          hour: 'numeric', minute: '2-digit' })
      : '';
    const agreed = value.agreed ? 'agreed' : 'NOT ticked';
    return [value.name, agreed, stamp].filter(Boolean).join(' · ');
  }

  if (Array.isArray(value)) {
    // A fillable grid: rows of cells.
    if (value.some((row) => Array.isArray(row))) {
      return value
        .map((row) => (Array.isArray(row) ? row.filter((c) => c !== '' && c != null).join(' | ') : row))
        .filter(Boolean)
        .join('\n');
    }
    return value.filter((v) => v !== '' && v != null).join(', ');
  }

  if (typeof value === 'object') {
    const parts = [value.value, ...(Array.isArray(value.values) ? value.values : []), value.other];
    return parts.filter((v) => v !== '' && v != null).join(', ');
  }

  return String(value);
};

export default answerText;
